import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Product } from '../../../core/interfaces/product-sale.interface';
import { DropdownSelector, SelectedProductItem } from '../../../core/interfaces/selector.interface';
import { ProductService } from '@app/core/services/product.service';
import { MULTI_SELECT_SETTING, EMULTI_SELECT_SETTING } from '../../../core/settings/settings.service';

@Component({
  selector: 'app-parking-result-card',
  templateUrl: './parking-result-card.component.html',
  styleUrls: ['./parking-result-card.component.scss']
})
export class ParkingResultCardComponent implements OnInit {

  @Input() set result(newvalue: Product) {
    this._result = newvalue;
    this.mapOptions();
  };

  @Output() parkSelect = new EventEmitter<SelectedProductItem>();
  @Output() parkRemove = new EventEmitter<string>();

  modalRef: BsModalRef;
  addEnabled: boolean = true;

  _result: Product;
  totalResult: number;

  options: DropdownSelector[] = [];
  optionSelected: DropdownSelector[] = [];

  protected readonly multiselectSettings = MULTI_SELECT_SETTING;
  protected readonly EMULTI_SELECT_SETTING = EMULTI_SELECT_SETTING;

  constructor(
    private modalService: BsModalService,
    private productService: ProductService,
  ) { }

  ngOnInit(): void {
    this.totalResult = this.productService.calculateExternalProductTotal(this._result);
  }

  mapOptions() {
    if (this._result) {

      this.options = [];

      const limit = Math.min(this._result.customFieldsExternal?.availablePlaces, this._result.customFieldsExternal?.maxQuantity);

      for (let i = 0; i <= limit; i++) {

        const opt = {
          id: i,
          itemName: `${i} `
        } as DropdownSelector

        this.options.push(opt);

      }

      if (this.options.length) {
        this.optionSelected = [this.options[0]];
      }
    }
  }

  isParkFull(): boolean {
    return this.options.length === 1 && this.options[0].itemName.trim() === '0';
  }

  openModal(template: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'modal-lg modal-dialog-centered modal-dialog-scrollable resized-modal' }));
  }

  selectParkAmount() {
    const amount = +this.optionSelected[0].itemName;

    this._result.customFieldsExternal.quantitySelected = amount;

    if (amount) {
      this.parkSelect.emit({product: this._result, amount});
    } else {
      this.parkRemove.emit(this._result.itemCode);
    }
  }

  deselectParkAmount() {
    this.parkRemove.emit(this._result.itemCode);
  }

}
